import { useMemo } from 'react';

import { MappingCollections } from '@scaleaq/sitecontrol-lib';

import { translateUnitLabel } from '@/utils';

export const useEventClassUnitPair = () => {
  const formatUnit = (unit: string) => {
    if (unit === 'Unitless') return undefined;
    return translateUnitLabel(unit);
  };

  const units = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(MappingCollections.eventClassUnitPair).map(([key, value]) => [
          key,
          formatUnit(value),
        ])
      ),
    []
  );
  return { units };
};
